import { Service } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { servicesServicesService } from '@services/requests/servicesService/servicesServicesService';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantServicesProcessor запрашивает услуги по вариантам и группирует по id варианта
 */
export class VariantServicesProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const variantsServices: { [T in string]: Service[] } = {};
    const loadedServicesByParentId: { directoryID: string; services: Service[] }[] = [];

    const loadedServices = await servicesServicesService().LoadServiceByDirectoryID(
      additionalServiceState.Variants.filter((variant) => variant.is_active).map((s) =>
        parseInt(s.id)
      )
    );

    loadedServices.forEach((s) => {
      const dirIndex = loadedServicesByParentId.findIndex(
        (service) => +service.directoryID === s.parent
      );

      if (dirIndex !== -1) {
        loadedServicesByParentId[dirIndex].services.push(s);
        return;
      }

      loadedServicesByParentId.push({ directoryID: s.parent.toString(), services: [s] });
    });

    loadedServicesByParentId.map((r) => {
      variantsServices[r.directoryID] = r.services;
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantServices: variantsServices,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
